import styled, { css } from 'styled-components';

export const StyledCurrentValue = styled.div`
    ${({ theme, state }) => state !== 0 && css`
        position: relative;
        color: ${theme.pastelRed};
        position: relative;
        padding-left: 20px;
        &:before {
            content: '';
            position: absolute;
            top: 50%;
            left: 0;
            margin-top: -7px;
            display: block;
            width: 14px;
            height: 12px;
            border-style: solid;
            border-width: 12px 7px 0 7px;
            border-color: ${({ theme }) => theme.pastelRed} transparent transparent transparent;
            transform: ${({ state }) => state > 0 ? 'rotate(180deg)' : 'rotate(0deg)'};
        }
    ` } 
`